/** @format */

// src/plugins/vuetify.js

import 'vuetify/dist/vuetify.min.css';

import Vue from 'vue';
import Vuetify from 'vuetify';
import colors from 'vuetify/lib/util/colors';

Vue.use(Vuetify);

const vuetify = new Vuetify({
	theme: {
		themes: {
			light: {
				primary: colors.purple,
				secondary: colors.grey.darken1,
				accent: colors.shades.black,
				error: colors.red.accent3,
			},
			dark: {
				primary: colors.blue.lighten3,
				error: colors.red.accent3,
			},
		},
	},
});
export default vuetify;
